import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import SupportedBrowser from '@/components/video-diagnostic/SupportedBrowser.vue'
import UnSupportedBrowser from '@/components/video-diagnostic/UnSupportedBrowser.vue'
import { Stage, Topic } from '@/types/enums/video-diagnostic.enum'
import { IUpdateTopic } from '@/types/interfaces/video-diagnostic.interface'
import { watch } from 'vue'
import Video from 'twilio-video'

interface BrowserTestEmits {
  (e: 'nextStage', value: number): void
  (e: 'updateTopic', value: IUpdateTopic): void
  (e: 'supportedBrowser', value: boolean): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BrowserTest',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  emits: ["nextStage", "updateTopic", "supportedBrowser"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

watch(
  () => props.stage,
  (stage, prevStage) => {
    if (stage === Stage.BROWSER_TEST) {
      emit('updateTopic', { topic: Topic.CONNECTIVITY, active: true })
      emit('supportedBrowser', Video.isSupported)
    }
    if (prevStage === Stage.BROWSER_TEST && stage === Stage.AUDIO_TEST) {
      emit('updateTopic', { topic: Topic.CONNECTIVITY, active: false })
      emit('supportedBrowser', true)
    }
  },
)

return (_ctx: any,_cache: any) => {
  return (_unref(Video).isSupported)
    ? (_openBlock(), _createBlock(SupportedBrowser, {
        key: 0,
        stage: __props.stage,
        onNextStage: _cache[0] || (_cache[0] = ($event: any) => (emit('nextStage', _unref(Stage).CONNECTIVITY)))
      }, null, 8, ["stage"]))
    : (_openBlock(), _createBlock(UnSupportedBrowser, {
        key: 1,
        stage: __props.stage
      }, null, 8, ["stage"]))
}
}

})